var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-icon"},[(!_vm.icon)?_c('md-icon',[_vm._v("extension")]):(_vm.icon.startsWith('http'))?_c('img',{staticClass:"icon-image",attrs:{"src":_vm.icon}}):_c('md-icon',[_vm._v(_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }